jQuery(function($){

    // JQUERY MASK //
    $('.mask-date').mask('00/00/0000', {});
    $('.mask-time').mask('00:00:00', {});
    $('.mask-date-time').mask('00/00/0000 00:00:00', {});
    $('.mask-cep').mask('00000-000', {});
    $('.mask-cpf').mask('000.000.000-00', { reverse: true });
    $('.mask-cnpj').mask('00.000.000/0000-00', { reverse: true });
    $('.mask-money').mask('000.000.000.000.000,00', { reverse: true });

    var PoneMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      phone_Options = {
        onKeyPress: function(val, e, field, options) {
            field.mask(PoneMaskBehavior.apply({}, arguments), options);
          }
      };
      
    $('.mask-tel').mask(PoneMaskBehavior, phone_Options);
    // JQUERY MASK //
    
});


// Remove the transition class
const animates = document.querySelectorAll('.animate');

// Create the observer, same as before:
const observer = new IntersectionObserver(
    entries => {
        entries.forEach(entry => {
            entry.target.classList.toggle("in-view", entry.isIntersecting);
            if(entry.isIntersecting) observer.unobserve(entry.target);            
        });
    },
    {
        threshold: 0.5
    }
);

animates.forEach(animate => {
    observer.observe(animate);
});
